/**
 * ขั้นต่ำต่อช่องทางฝาก — ที่เดียวของทั้งล็อบบี้ ทุกเว็บใช้ไฟล์นี้เหมือนกัน
 *
 * พร้อมเพย์ (QR เข้าวอลเล็ท) โดนค่าธรรมเนียมเป็นรายการ ไม่ใช่เป็นเปอร์เซ็นต์
 * ⇒ ยอดเล็กยิ่งฝากยิ่งขาดทุน จึงตั้งพื้นไว้ที่ 200 (เจ้าของงานสั่ง 30 ก.ย. 69)
 *
 * บังคับใน TruewalletTopup เลย ไม่ได้ปล่อยให้หน้าที่เรียกส่งมาเอง
 * เพราะมีหน้าที่เรียกอยู่ 16 เว็บ ลืมที่เดียวก็รั่วที่นั่น
 */
export const MIN_PROMPTPAY_DEPOSIT = 200;
